import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Icon } from 'components/ui';
import { showErrorNotification } from 'services/common';
import TemplateEditorModal from './TemplateEditorModal';
import './style.css';
import TemplateTable from './TemplateTable';
import ShowOnlyActiveCheckBox from './Filtering/ShowOnlyActiveCheckBox';
import ShowOnlyAmpCheckBox from './Filtering/ShowOnlyAmpCheckBox';

class Templates extends Component {
  state = {
    showEditTemplateModal: false,
    showEditWebhookModal: false,
    showConfirmDeleteModal: false,
    activeTemplateId: -1,
  };

  componentDidUpdate(prevProps) {
    this.showErrors(prevProps);
  }

  async componentDidMount() {
    this.fetchTemplateAndOpenModal(this.props.activeTemplate);
  }

  showErrors = prevProps => {
    if (this.props.error && prevProps.error !== this.props.error) {
      showErrorNotification(this.props.error);
    }
  };

  fetchTemplateAndOpenModal = templateId => {
    if (!templateId) return;
    this.setState({
      activeTemplateId: templateId,
      showEditTemplateModal: true,
    });
  };

  handleAddTemplate = () => {
    this.setState({
      activeTemplateId: -1,
      showEditTemplateModal: true,
    });
  };

  handleEditTemplate = templateId => {
    this.setState({
      activeTemplateId: templateId,
      showEditTemplateModal: true,
    });
  };

  handleConfirmDeleteTemplate = id => {
    this.props.onDeleteTemplate(id);
  };

  handleHideEditTemplateModal = () => {
    this.setState({ showEditTemplateModal: false });
  };

  handleAddOrEditTemplate = template => {
    const { onAddTemplate, onEditTemplate } = this.props;
    const isNewTemplate = this.state.activeTemplateId < 0;
    const saveFunction = isNewTemplate ? onAddTemplate : onEditTemplate;
    this.handleHideEditTemplateModal();
    saveFunction(template);
  };

  render() {
    const { categories, emailTypes } = this.props;
    const { showEditTemplateModal } = this.state;

    return (
      <div className="templates" style={{ width: '100%' }}>
        <Row
          align="middle"
          className="templates__header"
          style={{ marginBottom: 10 }}
          type="flex"
        >
          <Col span={12}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <ShowOnlyActiveCheckBox />
              <ShowOnlyAmpCheckBox />
            </div>
          </Col>
          <Col span={12}>
            <div className="flex" style={{ justifyContent: 'right' }}>
              <Button
                className="templates__add-template-btn"
                id="new-template-modal-open-btn"
                onClick={this.handleAddTemplate}
              >
                <Icon type="plus" />
                Create New Template
              </Button>
            </div>
          </Col>
        </Row>
        <TemplateTable
          handleAddOrEditTemplate={this.handleAddOrEditTemplate}
          handleDeleteTemplate={this.handleConfirmDeleteTemplate}
          onEditTemplate={templateId => {
            this.handleEditTemplate(templateId);
          }}
        />
        <TemplateEditorModal
          categories={categories}
          emailTypes={emailTypes}
          isVisible={showEditTemplateModal}
          key={Number(this.state.activeTemplateId)}
          templateId={Number(this.state.activeTemplateId)}
          onHideModal={this.handleHideEditTemplateModal}
          onSaveTemplate={this.handleAddOrEditTemplate}
        />
      </div>
    );
  }
}

Templates.defaultProps = {
  isLoading: false,
  templates: [],
  categories: [],
};

Templates.propTypes = {
  error: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  templatesCount: PropTypes.number,
  onAddTemplate: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
};

export default Templates;
